<template>
<div class="cart">
  <ul>
    <li v-for="(item, ii) in cartItems">
      <template v-if="item.type=='discount'">
        Discount <span class="price">$ {{ (item.price*1 || 0).toFixed(2) }}</span>
      </template>
      <template v-else>
<!--         <span class="subtitle">{{ item.video?item.video.subtitle:" " }}</span> -->
        <span v-if="item.type=='membership'" class="title">Membership</span>
        <span v-else class="title">{{ item.video?item.video.title:item.group.title }}</span>
        <span v-if="item.type=='membership'" class="price">$ 129.00</span>
        <span v-else class="price">{{ formatPrice(item.price[0], item.price[1]) }}</span>
        <span class="duration" v-if="item.duration">{{ item.duration }} days</span>
      </template>
      <a class="remove" href="" v-on:click.prevent="popItem(ii)">&times;</a>
    </li>
  </ul>
  <div class="total" v-if="cartItems && cartItems.length">
    <span class="total-price">$ {{ totalPrice }}</span>
    <span class="label">IN TOTAL</span>
    <label class="tc"><input type="checkbox" v-model="agreeTc" />I agree to the <a href="" v-on:click.prevent="showTc">Terms and Conditions</a></label>
    <div class="discount-code" v-if="loggedIn">
      <input v-if="!discountApplied" type="text" v-model="discount" placeholder="Apply discount code here" />
      <span v-else>Code applied: <em>{{ discountApplied.discountkey }}</em></span>
      <a href="" class="discount-button" v-on:click.prevent="applyDiscount" v-if="discount">Apply</a>
<!--       <router-link v-else :to="{name: 'user.profile'}" class="button" v-on:click.native="$parent.cartOpen=false">PROCEED TO PAYMENT</router-link> -->
      <router-link v-if="false && hasPayPal" :to="{name: 'user.profilepp'}" class="button" v-on:click.native="$parent.cartOpen=false">PayPal</router-link>
    </div>
    <a href="" v-if="!agreeTc" class="button disabled" v-on:click.prevent="">PROCEED TO PAYMENT</a>
    <router-link v-else :to="{name: 'user.profile'}" class="button" v-on:click.native="$parent.cartOpen=false;">PROCEED TO PAYMENT</router-link>
  </div>
  <div class="empty" v-else>
    <span>(cart empty)</span>
  </div>
</div>
</template>

<script>
import Cookies from 'js-cookie';
import formatters from './formatters';
import moment from 'moment';
export default {
  mixins: [formatters],
  data: ()=>({
    cartItems: [],
    agreeTc: false,
    discount: "",
    discountApplied: null,
  }),
  computed: {
    loggedIn() {
      return appRoot.loggedIn;
    },
    hasPayPal() {
      return appData.hasPayPal;
    },
    totalPrice() {
      return this.cartItems.map((a)=>a.type=='discount'?a.price:a.type=='membership'?149:this.formatPriceRaw(a.price[0], a.price[1])).reduce((a,b)=>a*1+b*1, 0).toFixed(2);
    },
  },
  methods: {
    async applyDiscount() {
      var now=moment().format("YYYY-MM-DD HH:mm:ss");
      var video=this.cartItems.find(a=>a.video && a.video.discountkey==this.discount && a.video.discountexpiry>now);
      var discount=video?{...video.video}:null;
      if (discount)
        discount.price=[{price: this.formatPriceRaw(video.price[0], video.price[1])}, "price"];
      if (!discount)
        return appNotifications.show("Invalid discount code", "error");
      var alreadyApplied=(await api.list("Payment", {status: "captured", discount: discount.id, userid: this.loggedIn.id})).items[0];
      if (alreadyApplied)
        return appNotifications.show("Discount code already applied", "error");
      this.pushItem("c", null, discount.id);
      this.discount="";
      return appNotifications.show("Discount code applied", "success");
    },
    showTc() {
      appRoot.tcVisible=true;
    },
    async updateCartItems() {
      var currentUser=appRoot.loggedIn || {};
      var allPayments=currentUser.allPayments || [];
      var cart=[];
      try {
        cart=(Cookies.get("appcart") || "").split(",").filter((a)=>a);
      } catch(e) { } 
      var cartItemsAwait=[];
      for(var item of cart) {
        var variant=item.split("-")[1] || null;
        item=item.split("-")[0];
        if (item[0]=="c")
          cartItemsAwait.push([item, api.get('Video', variant), variant]);
        else if (item[0]=="m")
          cartItemsAwait.push([item, {item: {}}, variant]);
        else
          cartItemsAwait.push([item, api.get(item[0]=="g"?"VideoGroup":"Video", item.substring(1)), variant]);
      }
      this.discountApplied=null;
      var cartItems2=[];
      for(var item of cartItemsAwait) {
        var xitem=[item[0], (await item[1]).item, item[2]];
        cartItems2.push(xitem);
        if (item[0]=="c")
          this.discountApplied=xitem[1];
      }
      var cartItems=[];
      
//       var discount=video?{...video.video}:null;
//       discount.price=[{price: this.formatPriceRaw(video.price[0], video.price[1])}, "price"];

      
      for(var item of cartItems2) {
        if (item[0][0]=="c") {
          cartItems.push({
            discount: item[1],
            group: null,
            video: null,
            type: "discount",
            price: 0,
          });
        } else if (item[0][0]=="m") {
          cartItems.push({
            video: null,
            group: null,
            duration: 365,
            price: 129,
            type: "membership",
          });
        } else if (item[0][0]=="g") {
          var duration=([30, 90, 180, 365])[item[2]];
          var field=(["priceUsd", "renewPriceUsd", "renewPrice2Usd", "renewPrice3Usd"])[item[2]];
          var price=[item[1], field];
            
          cartItems.push({
            video: null,
            group: item[1],
            duration,
            price,
          });
        } else {
          var duration=([1, 3, 7, 30, 90])[item[2]];
          var field=(["priceUsd","price1","price2","price3","price4"])[item[2]];
          var price=[item[1], field];
          
          cartItems.push({
            video: item[1],
            group: item[1].group,
            duration,
            price,
          });          
        }
      }
      if (false) {
        var cartItems2=cartItems.filter((a)=>a.type!="discount");
        var discount=cartItems.find((a)=>a.type=="discount");
        if (discount && discount.onlyFirst) {
          if (cartItems2[0]) {
            var fiPrice=this.formatPriceRaw(cartItems2[0].price[0], cartItems2[0].price[1]);
            console.log(fiPrice, discount);
            discount.price=Math.min(0, -1*(fiPrice/100*discount.percent+(discount.amount || 0)*1));
          }
          cartItems2.splice(1, 0, discount);
        } else if (discount) {
          discount.price=0;
          for(var cartItem of cartItems2) {
            var fiPrice=this.formatPriceRaw(cartItem.price[0], cartItem.price[1]);
  //           console.log(fiPrice, discount);
            discount.price+=Math.min(0, -1*(fiPrice/100*discount.percent+(discount.amount || 0)*1));
          }
          cartItems2.push(discount);
        }
        this.cartItems=cartItems2;
      } else {
        var discount=cartItems.find((a)=>a.type=="discount");
        if (discount) {
          var item=cartItems.find(a=>a.video && a.video.id==discount.discount.id);
          discount.price=-0.01*this.formatPriceRaw(item.price[0], item.price[1])*item.video.discountpercent;
        }
        this.cartItems=cartItems;
      }
      
    },
    pushItem(type, id, variant) {
//       console.log({type, id, variant});
      var cart=[];
      try {
        cart=(Cookies.get("appcart") || "").split(",").filter((a)=>a);
      } catch(e) { } 
      if (type=='c' && cart.indexOf("c-")!=-1)
        return;
      if (type=='m' && cart.indexOf("m-")!=-1)
        return;
      if (cart.indexOf(type+id+"-"+(variant||"0"))!=-1)
        return;
      cart.push(type+(id||"")+"-"+(variant||"0"));
      Cookies.set("appcart", cart.join(","), {path: "/"});
      appNotifications.show("Item added to cart", "success");
      this.updateCartItems();
    },
    popItem(index) {
      var cart=[];
      try {
        cart=(Cookies.get("appcart") || "").split(",").filter((a)=>a);
      } catch(e) { } 
      cart.splice(index, 1);
      Cookies.set("appcart", cart.join(","), {path: "/"});
      this.updateCartItems();
    },
  },
  mounted() {
    window.appCart=this;
    this.updateCartItems();
  },
}

</script>
